/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableLoading} from '../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {getLaundryGenerateBatch} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {ColumnTable} from './columns'
import {FormLaundryBatch} from './form'

const TableLaundryGenerateBatch: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
  } = useKTable()

  const {isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [formValues, setFormValues] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<boolean>(false)
  const {columns} = ColumnTable()
  const getLaundryBatchList = async () => {
    if (formValues) {
      setLoading(true)
      let obj = {...searchValues, ...formValues}
      const response = await getLaundryGenerateBatch(obj, pagination.currentPage)
      const dataInfo = response.data?.data || []
      if (!response.data.error) {
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getLaundryBatchList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getLaundryBatchList()
      // getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getLaundryBatchList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getLaundryBatchList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTable(false)
    }
  }, [clearTable])

  return (
    <KTCard shadow>
      <FormLaundryBatch
        getLaundryList={getLaundryBatchList}
        formValues={formValues}
        setFormValues={setFormValues}
        formValueLoading={formValueLoading}
        setFormValueLoading={setFormValueLoading}
      />
      {isAllowed('LISTAR') && (
        <>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </>
      )}
    </KTCard>
  )
}

const TableLaundryGenerateBatchWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryGenerateBatch />
    </KTableProvider>
  )
}

export {TableLaundryGenerateBatchWrapper}
